import { useState } from "react";
import { Box, Button, TextField } from "@material-ui/core";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";

import { useSummaryStyles } from "./summary.styles";
import { SummaryDate } from "./SummaryDate";
import { SummaryTotal } from "./SummaryTotal";
import { SummaryAddon } from "./SummaryAddon";
import { SummaryPackage } from "./SummaryPackage";
import { Potential } from "./Potential";
import { applyPromoCode } from "../../../../api/Quote/QuoteApi";
import { fetchQuote } from "../../../../store/QuoteSlice";
import { RootState } from "../../../../app/rootReducer";

export const Summary = ({ quoteId }: { quoteId: string }) => {
  const classes = useSummaryStyles();
  const [discountCode, setDiscountCode] = useState<string>();
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const { quote } = useSelector((state: RootState) => state.quote);

  const onApplyPromoCode = async (promoCode?: string) => {
    if (!quote || !promoCode) return;
    try {
      setLoading(true);
      await applyPromoCode(quote.id, promoCode);
      dispatch(fetchQuote(quoteId));
      setDiscountCode("");
      setLoading(false);
      toast.success(`Discount code ${promoCode} has been successfully applied`);
    } catch (err: any) {
      const message = err?.message ?? err;
      setLoading(false);
      toast.error(message);
    }
  };

  return (
    <>
      <Box bgcolor={"#fff"} marginBottom={"15px"} boxShadow={"0 0 15px 0 rgba(0, 0, 0, 0.07)"} className={classes.root}>
        <Box className={classes.summaryHeader}>
          <h2 className={classes.summaryTitle}>Summary</h2>
          <Box className={classes.summaryDiscountForm}>
            <TextField
              className={classes.summaryDiscountFormInput}
              placeholder="Add Discount Code"
              variant="outlined"
              onChange={(e) => setDiscountCode(e.target.value)}
              value={discountCode}
              disabled={loading}
            />
            <Button
              className={classes.summaryDiscountFormButton}
              disabled={loading}
              onClick={() => onApplyPromoCode(discountCode)}
            >
              Apply
            </Button>
          </Box>
        </Box>
        <SummaryPackage />
        <SummaryAddon quoteId={quoteId} />
        <SummaryDate />
        <SummaryTotal quoteId={quoteId} />
      </Box>
      {quote?.type.includes("Solar") && <Potential />}
    </>
  );
};
